import { render } from "./permission.html?vue&type=template&id=1a6cc6e4&external"
import script from "./permission.js?vue&type=script&lang=js&external"
export * from "./permission.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__